import {
  IonAccordion,
  IonAccordionGroup,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
import { useHistory } from "react-router";
import "./FAQ.css";

const FAQ = () => {
  const history = useHistory();
  return (
    <IonPage className={"faq-page-root"}>
      <IonHeader className={"ion-no-border"}>
        <IonToolbar className={"background-color"}>
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon icon={chevronBackOutline} color="dark" size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>Frequently Asked Questions</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonAccordionGroup>
          <IonAccordion value="oshi">
            <IonItem slot="header">
              <IonLabel className={"ion-text-wrap"}>What is Oshi?</IonLabel>
            </IonItem>

            <IonList slot="content">
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  Oshi is a hyper-verticalized local promotions marketplace. By
                  leveraging the speed and efficiency of bitcoin technology
                  we’re able to offer game-changing incentives to merchants,
                  consumers, and evangelists alike.
                </IonLabel>
              </IonItem>
            </IonList>
          </IonAccordion>
          <IonAccordion value="work">
            <IonItem slot="header">
              <IonLabel className={"ion-text-wrap"}>How does it work?</IonLabel>
            </IonItem>

            <IonList slot="content">
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  <strong>Consumers: </strong>
                  Browse and purchase promotions for local goods and services
                  all from a single platform. Redeem the promotion in-store via
                  a unique QR code.
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  <strong>Merchants: </strong>Craft unique, customizable
                  promotions for your local community to view and purchase. Your
                  customers instantly receive a QR code, you instantly receive
                  their money.
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  <strong>Evangelists: </strong>Onboard local merchants and
                  accrue bitcoin rewards when they sell via Oshi.
                </IonLabel>
              </IonItem>
            </IonList>
          </IonAccordion>
          <IonAccordion value="promotions">
            <IonItem slot="header">
              <IonLabel className={"ion-text-wrap"}>
                How do I purchase promotions?
              </IonLabel>
            </IonItem>

            <IonList slot="content">
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  Payments are settled over Bitcoin’s lightning network. Don’t
                  know what that means or how it works? No problem.
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  Just download the{" "}
                  <a
                    href="https://strike.zaphq.io/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Strike App
                  </a>
                  , complete the onboarding in less than a minute, pay your Oshi
                  invoice, and unlock a revolutionary way to engage in local
                  commerce.
                </IonLabel>
              </IonItem>
            </IonList>
          </IonAccordion>
          <IonAccordion value="crypto">
            <IonItem slot="header">
              <IonLabel className={"ion-text-wrap"}>
                Can I pay with other cryptocurrencies?
              </IonLabel>
            </IonItem>

            <IonList slot="content">
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>Nah.</IonLabel>
              </IonItem>
            </IonList>
          </IonAccordion>
          <IonAccordion value="rewards">
            <IonItem slot="header">
              <IonLabel className={"ion-text-wrap"}>
                How do rewards work?
              </IonLabel>
            </IonItem>

            <IonList slot="content">
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  The rewards are denominated in satoshis, therefore they will
                  fluctuate in USD value based on the current market price of
                  bitcoin. A satoshi is the smallest unit of measurement for
                  bitcoin. While there are 100 pennies in a dollar, there are
                  100,000,000 satoshis in a bitcoin. You may choose to save,
                  spend, or withdraw the rewards to your personal bitcoin
                  wallet.{" "}
                </IonLabel>
              </IonItem>
            </IonList>
          </IonAccordion>
          <IonAccordion value="deny">
            <IonItem slot="header">
              <IonLabel className={"ion-text-wrap"}>
                What if I don't want Bitcoin rewards?
              </IonLabel>
            </IonItem>

            <IonList slot="content">
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  No problem! Each standard promotion gives you the option to
                  either save money or earn bitcoin ‘cashback’ rewards. Say
                  goodbye to coffee points, corporate cash, and rewards stars.
                  Say hello to rewards freedom. You may choose to save, spend,
                  or withdraw the rewards to your personal bitcoin wallet.
                </IonLabel>
              </IonItem>
            </IonList>
          </IonAccordion>
          <IonAccordion value="merchant">
            <IonItem slot="header">
              <IonLabel className={"ion-text-wrap"}>
                As a merchant, what if I want to receive dollars instead of
                Bitcoin?
              </IonLabel>
            </IonItem>

            <IonList slot="content">
              <IonItem>
                <IonLabel className={"ion-text-wrap"}>
                  No problem! You can receive either bitcoin, USD, or a
                  combination of both. Your choice.
                </IonLabel>
              </IonItem>
            </IonList>
          </IonAccordion>
        </IonAccordionGroup>
      </IonContent>
    </IonPage>
  );
};

export default FAQ;
